import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SolicitanteDetailComponent } from '../../_importacion/solicitudes/datosbasicos/solicitante/solicitante-detail.component';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import {
    AccessSolicitudExGuard,
    AccessSolicitanteExGuard,
    AccessProductoExGuard,
    ActionEstadoExGuard,
    AccessDocumentosExGuard,
    AccessSeguimientoExGuard,
    AccessEmbalajeExGuard,
} from '../_classes/access.guard';
import { AlegacionExComponent } from './alegacion/alegacionEx.component';
import { DocumentoAlegacionExEditComponent } from './alegacion/documentoAlegacionEx-edit.component';
import { AnulacionExEditComponent } from './anulacion/anulacionEx-edit.component';
import { SolicitudExEditComponent } from './datosbasicos/solicitudEx-edit.component';
import { DeclSuplementariaExComponent } from './declsuplemetaria/declsuplemetaria.component';
import { DocumentosExEditComponent } from './documentos/documentosEx-edit.component';
import { DocumentosExListComponent } from './documentos/documentosEx-list.component';
import { CopiaCFExEditComponent } from './envio/copiaCF/copiaCFEx-edit.component';
import { EnvioExComponent } from './envio/envioEx.component';
import { NumeroSeguridadEditComponent } from './envio/numerosseguridad/numerosseguridad-edit.component';
import { InspeccionesExComponent } from './inspecciones/inspeccionesEx.component';
import { PreviaInspectorExEditComponent } from './previaInspector/previaInspectorEx-edit.component';
import { EmbalajeExEditComponent } from './productos/embalajesEx-edit.component';
import { ProductoExEditComponent } from './productos/productosEx-edit.component';
import { ProductosSolicitudExListComponent } from './productos/productosEx-list.component';
import { ReexportacionEditComponent } from './reexportacion/reexportacion-edit.component';
import { RelacionatestacionesComponent } from './relacionatestaciones/relacionatestaciones.component';
import { TasasExComponent } from './tasas/tasasEx.component';
import { TipoSolicitudExListComponent } from './tipossolicitudes/tiposolicitudEx-list.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { LaboratorioExWrapperComponent } from './laboratorio/laboratorioEx-wrapper/laboratorioEx-wrapper.component';
import { LaboratorioExDocumentosEditComponent } from './laboratorio/laboratorioEx-documentos-edit/laboratorioEx-documentos-edit.component';
import { SeguimientoExEditComponent } from './seguimiento/seguimientoEx-edit.component';
import { SeguimientosExListComponent } from './seguimiento/seguimientosEx-list.component';
import { ReasignacionPcfWrapperComponent } from './inspecciones/reasignacionpcf-wrapper/reasignacionpcf-wrapper.component';

const solicitudesExRoutes: Routes = [
    {
        path: 'exportacion/solicitud',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'EXPORTACIÓN',
            //menu1: 'Solicitudes'//,//,
            //,
            overridePath: 'exportacion/solicitudes',
        },
        children: [
            { path: '', redirectTo: 'tipossolicitudesEx', pathMatch: 'full' },
            {
                path: 'tipossolicitudesEx',
                component: TipoSolicitudExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Tipo Solicitud',
                    actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_EXPORTACION,
                },
            },
            {
                path: 'datosbasicosEx/create',
                data: {
                    breadcrumb: 'Nueva',
                },
                children: [
                    {
                        path: '',
                        component: SolicitudExEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_EXPORTACION,
                            reuseComponent: false,
                        },
                    },
                    {
                        path: 'solicitante/:id',
                        component: SolicitanteDetailComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_EXPORTACION,
                            breadcrumb: 'Detalle Solicitante',
                        },
                    },
                ],
            },
            {
                path: 'datosbasicosEx/:id',
                data: {
                    breadcrumb: 'Datos Básicos',
                },
                children: [
                    {
                        path: '',
                        component: SolicitudExEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_EXPORTACION,
                            reuseComponent: false,
                        },
                    },
                    {
                        path: 'solicitante/:id',
                        component: SolicitanteDetailComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitanteExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_EXPORTACION,
                            //breadcrumb: 'Detalle Solicitante'
                            breadcrumb: 'Detalle Solicitante',
                        },
                    },
                ],
            },

            //MENU PRODUCTOS
            {
                path: 'productosEx/:id',
                data: {
                    breadcrumb: 'Productos',
                },
                children: [
                    {
                        path: '',
                        component: ProductosSolicitudExListComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_EXPORTACION,
                        },
                    },
                    {
                        path: 'create',
                        component: ProductoExEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_EXPORTACION,
                        },
                    },
                    {
                        path: 'producto/:idprod',
                        component: ProductoExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessProductoExGuard()],
                        data: {
                            breadcrumb: 'Editar Producto',
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_EXPORTACION,
                        },
                    },
                    {
                        path: 'create_packing',
                        component: EmbalajeExEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_EXPORTACION,
                        },
                    },
                    {
                        path: 'embalaje/:idemb',
                        component: EmbalajeExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessEmbalajeExGuard()],
                        data: {
                            breadcrumb: 'Editar Embalaje',
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_EXPORTACION,
                        },
                    },
                ],
            },

            //ANULACION
            {
                path: 'anulacionEx/:id',
                component: AnulacionExEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION_EXPORTACION,
                    menu0: 'Anulación',
                },
            },

            //PREVIA
            {
                path: 'previaEx/:id',
                component: PreviaInspectorExEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PREVIA_EXPORTACION,
                    menu0: 'Previa',
                },
            },
            //REEXPORTACION
            {
                path: 'reexportacion/:id',
                component: ReexportacionEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_REEXPORTACION,
                    menu0: 'Re-Exportación',
                },
            },
            //RELACION ATESTACIONES
            {
                path: 'atestaciones/:id',
                component: RelacionatestacionesComponent,
                canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_RELACION_ATESTACIONES_EXPORTACION,
                    menu0: 'Atestaciones',
                },
            },
            ////ENVIO
            //{
            //    path: 'envioEx/:id',
            //    component: EnvioExComponent,
            //    canActivate: [LoginGuard(), ActionGuard()Estado, AccessSolicitudExGuard()],
            //    data: {
            //        actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_EXPORTACION,
            //        menu0: 'Envío',
            //    },
            //},
            //ENVÍO
            {
                path: 'envioEx/:id',
                //component: EnvioExComponent,
                //canActivate: [LoginGuard(), ActionGuard()Estado, AccessSolicitudExGuard()],
                data: {
                    //actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_EXPORTACION,
                    //menu0: 'Envío',
                    breadcrumb: 'Envío',
                },
                children: [
                    {
                        path: '',
                        component: EnvioExComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_EXPORTACION,
                        },
                    },
                    {
                        path: 'createNumSeguridad',
                        component: NumeroSeguridadEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.NUEVO_NUM_SEGURIDAD,
                        },
                    },
                    {
                        path: 'createNumSeguridad/:numeroSeguridad',
                        component: NumeroSeguridadEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Editar Número Seguridad',
                            actionCode: EnumCodigosTwTcAcciones.NUEVO_NUM_SEGURIDAD,
                        },
                    },
                    {
                        path: 'createCopiaCF',
                        component: CopiaCFExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Nueva Copia',
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_BORRAR_COPIA_CF,
                        },
                    },
                    {
                        path: 'editCopiaCF/:idCopia',
                        component: CopiaCFExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Editar Copia',
                            actionCode: EnumCodigosTwTcAcciones.GUARDAR_COPIA_CF,
                        },
                    },
                ],
            },

            //TASAS
            {
                path: 'tasasEx/:id',
                component: TasasExComponent,
                canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_TASAS_EXPORTACION,
                    menu0: 'Tasas',
                },
            },

            //INSPECCIONES
            {
                path: 'inspeccionesEx/:id',
                //component: InspeccionesExComponent,
                //canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                data: {
                    //actionCode: EnumCodigosTwTcAcciones.MENU_INSPECCIONES_EXPORTACION,
                    //menu0: 'Inspecciones',
                    breadcrumb: 'Inspecciones',
                },
                children: [
                    {
                        path: '',
                        component: InspeccionesExComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_EXPORTACION,
                        },
                    },
                    {
                        path: 'reasignacionPcf',
                        component: ReasignacionPcfWrapperComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Reasignacion Manual de PCF',
                            actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_EXPORTACION,
                        },
                    },
                ],
            },

            //LABORATORIO
            {
                path: 'laboratorioEx/:id',
                data: {
                    breadcrumb: 'Laboratorio',
                },
                children: [
                    {
                        path: '',
                        component: LaboratorioExWrapperComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_LABORATORIO_EXPORTACION,
                        },
                    },
                    {
                        path: 'documento',
                        component: LaboratorioExDocumentosEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard()],
                        data: {
                            breadcrumb: 'Nuevo documento',
                            actionCode: EnumCodigosTwTcAcciones.VER_PANTALLA_DOCUMENTO_LABORATORIO_EXPORTACION,
                        },
                    },
                    {
                        path: 'documento/:idDocumento',
                        component: LaboratorioExDocumentosEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard()],
                        data: {
                            breadcrumb: 'Editar documento',
                            actionCode: EnumCodigosTwTcAcciones.VER_PANTALLA_DOCUMENTO_LABORATORIO_EXPORTACION,
                        },
                    },
                ],
            },

            //ALEGACIONES
            {
                path: 'alegacionEx/:id',
                data: {
                    breadcrumb: 'Alegaciones',
                },
                children: [
                    {
                        path: '',
                        component: AlegacionExComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_ALEGACIONES,
                        },
                    },
                    {
                        path: 'create',
                        component: DocumentoAlegacionExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ALEGACIONES,
                        },
                    },
                    {
                        path: 'detalleDocumento/:idDocumento',
                        component: DocumentoAlegacionExEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessDocumentosExGuard()],
                        data: {
                            breadcrumb: 'Detalle Documento',
                            actionCode: EnumCodigosTwTcAcciones.MENU_ALEGACIONES,
                        },
                    },
                ],
            },

            //DOCUMENTOS
            {
                path: 'documentosEx/:id',
                data: {
                    breadcrumb: 'Documentos',
                },
                children: [
                    {
                        path: '',
                        component: DocumentosExListComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_EXPORTACION,
                        },
                    },
                    {
                        path: 'create',
                        component: DocumentosExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_EXPORTACION,
                        },
                    },
                    {
                        path: 'detalleDocumento/:idDocumento',
                        component: DocumentosExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessDocumentosExGuard()],
                        data: {
                            breadcrumb: 'Detalle Documento',
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_EXPORTACION,
                        },
                    },
                ],
            },

            //SEGUIMIENTO
            {
                path: 'seguimientosEx/:id',
                data: {
                    breadcrumb: 'Seguimiento',
                },
                children: [
                    {
                        path: '',
                        component: SeguimientosExListComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
                        },
                    },
                    {
                        path: 'createSeguimiento',
                        component: SeguimientoExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
                        },
                    },
                    {
                        path: 'createSeguimiento/inspecciones',
                        component: SeguimientoExEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
                        },
                    },
                    {
                        path: 'detalleseguimiento/:idSeguimiento',
                        component: SeguimientoExEditComponent,
                        canActivate: [LoginGuard(), AccessSeguimientoExGuard()],
                        data: {
                            breadcrumb: 'Detalle Seguimiento',
                        },
                    },
                ],
            },

            //DECLARACIÓN SUPLEMENTARIA
            {
                path: 'declSuplementariaEx/:id',
                component: DeclSuplementariaExComponent,
                canActivate: [LoginGuard(), ActionEstadoExGuard(), AccessSolicitudExGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_DECLSUPLEMENTARIA_EXPORTACION,
                    menu0: 'Decl. Adicional',
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(solicitudesExRoutes)],
    exports: [RouterModule],
})
export class SolicitudesExRoutingModule {}
